
import eventBus from '~/event-bus'

export default {
  data () {
    return {
      notification: null,
      showSnackbar: false
    }
  },
  created () {
    eventBus.$on('notification', async notif => {
      if (this.showSnackbar) {
        this.showSnackbar = false
        await new Promise(resolve => setTimeout(resolve, 300))
      }

      if (typeof notif === 'string') notif = { msg: notif }
      if (notif.error) {
        notif.type = 'error'
        notif.errorMsg = (notif.error.response && (notif.error.response.data || notif.error.response.status)) || notif.error.message || notif.error
        if (typeof notif.errorMsg === 'string') notif.errorMsg = notif.errorMsg.replace('[noretry] ', '')
      }
      notif.type = notif.type || 'default'
      this.notification = notif
      this.showSnackbar = true
    })
  }
}
